module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/外付け4Kビデオ会議用カメラ.4f10c8c7.png";